import { createSlice } from "@reduxjs/toolkit";

const initialState = { selectedCharacterId: sessionStorage.getItem("selectedCharacterId") };

const characterSlice = createSlice({
  name: "character",
  initialState,
  reducers: {
    selectCharacter(state, action) {
      state.selectedCharacterId = action.payload;
      if (action.payload) sessionStorage.setItem("selectedCharacterId", action.payload);
      else sessionStorage.removeItem("selectedCharacterId");
    },
  },
});

export const { selectCharacter } = characterSlice.actions;
export default characterSlice.reducer;